import React, { useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";

import Sidebar from "../sidebar/Sidebar";
import SidebarBrand from "../sidebarBrand/SidebarBrand";

import Dashboard from "../dashboard/Dashboard";
import Task from "../Task/Task";
import TaskHistory from "../taskHistory/TaskHistory";
import BrandVoice from "../brandVoice/BrandVoice";
import Support from "../support/Support";
import Optimizely from "../catalog/Catalog";
import { ThirdPartyAppsService } from "../../services/thirdPartyApps/thirdPartyAppsService";
import "./MainContainer.css";

interface MainContainerProps {
  userType: "user" | "admin";
}

const MainContainer: React.FC<MainContainerProps> = ({ userType }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [hasOptimizelyApp, setHasOptimizelyApp] = useState(false);

  useEffect(() => {
    async function checkOptimizelyApp() {
      try {
        const res = await ThirdPartyAppsService.getApps();
        const appsList = res.data?.data || [];
        setHasOptimizelyApp(
          appsList.some((a) => a.name.toLowerCase().includes("optimizely"))
        );
      } catch (_) {}
    }
    checkOptimizelyApp();
  }, []);

  const currentTab = location.pathname.split("/")[2] || "dashboard";

  const handleTabChange = (tab: string) => {
    navigate(`/${userType}/${tab}`);
  };

  return (
    <div className="app-container">
      {userType === "admin" ? (
        <SidebarBrand activeTab={currentTab} setActiveTab={handleTabChange} hasOptimizelyApp={hasOptimizelyApp} />
      ) : (
        <Sidebar activeTab={currentTab} setActiveTab={handleTabChange} hasOptimizelyApp={hasOptimizelyApp} />
      )}

      <div className="main-content">
        <Routes>
          <Route path="/" element={<Navigate to="dashboard" />} />

          {userType === "admin" ? (
            <>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="brand" element={<BrandVoice activeTab="brand" />} />
            </>
          ) : (
            <>
              <Route path="dashboard" element={<Dashboard />} />
            </>
          )}

          <Route path="tasks" element={<Task activeTab="tasks" />} />
          <Route path="optimizely" element={<Optimizely activeTab="optimizely" />} />
          <Route
            path="taskhistory"
            element={<TaskHistory activeTab="taskhistory" />}
          />
        </Routes>
      </div>
    </div>
  );
};

export default MainContainer;
